/**
 * @type {MutationObserverInit}
 */
export const MC_DEFAULT_OPTIONS = {
	attributes: true,
	childList: true,
	subtree: true
};

export class MutationController {

	/**
	 * @type {import('lit').ReactiveControllerHost}
	 */
	host;

	/**
	 * @type {MutationObserver}
	 */
	observer;

	/**
	 * @type {MutationObserverInit}
	 */
	observerOptions;

	/**
	 * @param {import('lit').ReactiveControllerHost} host
	 * @param {MutationObserverInit} observerOptions
	 * @param {()=>Promise<void>} observerCallback
	 */
	constructor (host, observerOptions = MC_DEFAULT_OPTIONS, observerCallback) {
		(this.host = host).addController(this);

		this.observerOptions = {
			...MC_DEFAULT_OPTIONS,
			observerOptions
		};

		this.observerCallback = observerCallback;
	}

	hostConnected () {
		this.observer = new MutationObserver(this.handleObserve.bind(this));
		this.observer.observe(this.host, this.observerOptions);
	}

	hostDisconnected () {
		this.observer.disconnect();
	}

	/**
	 * Handle the observer callback
	 */
	async handleObserve () {
		await this.host.updateComplete;

		let shouldRequestUpdate = true;
		if (typeof this.observerCallback === 'function') {
			shouldRequestUpdate = await this.observerCallback();
		}

		if (shouldRequestUpdate) {
			this.host.requestUpdate();
		}
	}
};

